import { render, staticRenderFns } from "./EditorArea.vue?vue&type=template&id=32797985&"
import script from "./EditorArea.vue?vue&type=script&lang=js&"
export * from "./EditorArea.vue?vue&type=script&lang=js&"
import style0 from "./EditorArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
